import { Box, Typography, Container } from "@mui/material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function ProductHeroSection() {
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "300px", md: "420px" },
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
      }}
    >
      {/* Background Image */}
      <img
        src="https://lh3.googleusercontent.com/gps-cs-s/AG0ilSz1zxdBVqUP3t8psUCgujWVSvO0_7foRmSw1tbqrQa42HczZUB4jZ0uWfnz9-ZdQAlzOkTCMvRR_BJ3zvXxa8h9KLxvO7Ed7Ws_Nge8SdoK16je3BB6w1Sh535mHklMStYldkJNDRxAbA=s1360-w1360-h1020-rw"
        alt="Products"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />

      {/* Blue Brand Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: `${brandBlue}CC`,
          zIndex: 2,
        }}
      />

      {/* Text Content */}
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 3 }}>
        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            mb: 2,
            fontSize: { xs: "1.8rem", md: "3rem" },
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Our Products
        </Typography>

        {/* Red underline */}
        <Box
          sx={{
            width: "80px",
            height: "4px",
            background: brandRed,
            mx: "auto",
            borderRadius: 2,
            mb: 3,
          }}
        />

        <Typography
          variant="h6"
          sx={{
            opacity: 0.95,
            fontSize: { xs: "1rem", md: "1.25rem" },
            maxWidth: "700px",
            mx: "auto",
          }}
        >
          Explore High-Performance Industrial Fabrication & Engineering
          Products.
        </Typography>
      </Container>
    </Box>
  );
}
